import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CookieModule } from 'ngx-cookie';
import { NgxMasonryModule } from 'ngx-masonry';
import { SharedDialogsModule } from '../shared-dialogs/shared-dialogs.module';
import { SharedModule } from '../shared/shared.module';
import { CategoryCardComponent } from './components/category-card/category-card.component';
import { CategoryTileComponent } from './components/category-tile/category-tile.component';
import { ChangeBillerOfferSummaryComponent } from './components/change-biller-offer-summary/change-biller-offer-summary.component';
import { DobryPradOfferDialogComponent } from './components/dobry-prad-offer-dialog/dobry-prad-offer-dialog.component';
import { DobryPradOfferFormComponent } from './components/dobry-prad-offer-form/dobry-prad-offer-form.component';
import { DobryPradOfferInfoComponent } from './components/dobry-prad-offer-info/dobry-prad-offer-info.component';
import { DobryPradWelcomeDialogComponent } from './components/dobry-prad-welcome-dialog/dobry-prad-welcome-dialog.component';
import { IframeOfferComponent } from './components/iframe-offer/iframe-offer.component';
import { OfferDetailsDialogComponent } from './components/offer-details/offer-details-dialog.component';
import { OfferTileComponent } from './components/offer-tile/offer-tile.component';
import { XsellOfferDetailsDialogComponent } from './components/xsell-offer-details/xsell-offer-details-dialog.component';
import { OffersComponent } from './containers/offers/offers.component';
import { OffersRoutingModule } from './offers-routing.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ContainerComponent } from '../shared/components/container/container.component';
import { EmptyStateComponent } from '../shared/components/empty-state/empty-state.component';
import { LoadingComponent } from '../shared/components/loading/loading.component';
import { IconComponent } from '../shared/components/icon/icon.component';

@NgModule({
  declarations: [
    OfferTileComponent,
    OfferDetailsDialogComponent,
    IframeOfferComponent,
    XsellOfferDetailsDialogComponent,
    ChangeBillerOfferSummaryComponent,
    XsellOfferDetailsDialogComponent,
    OffersComponent,
    CategoryCardComponent,
    CategoryTileComponent,
    DobryPradOfferDialogComponent,
    DobryPradOfferInfoComponent,
    DobryPradOfferFormComponent,
    DobryPradWelcomeDialogComponent,
  ],
  exports: [
    OfferTileComponent,
    OfferDetailsDialogComponent,
    IframeOfferComponent,
    ChangeBillerOfferSummaryComponent,
  ],
  imports: [
    OffersRoutingModule,
    CommonModule,
    RouterModule,
    SharedModule,
    NgxMasonryModule,
    ReactiveFormsModule,
    CookieModule,
    SharedDialogsModule,
    NgxMaskDirective, NgxMaskPipe, ContainerComponent, EmptyStateComponent, LoadingComponent, IconComponent,
  ],
  providers: [provideNgxMask()]
})
export class OffersModule {}
